module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAARCAYAAAAougcOAAAACXBIWXMAAAsSAAALEgHS3X78AAAA90lEQVQ4jd2UwW3CMBRAnxF3GCEbNBIWPsZswAaFDbpBO0I2gBHYgH+15EMYgQ1gAnNIUllpkwCJOPAuVvwdP3/722qxzFJAgBndbL2TfVtQG5sCObD2Ti5xbNIz8SOsgQxIm4Gpd1IA8xFlfxgzk1amz/6ojU2AxDuRlviccuuKIZlsgKM2dt8iEOAIpEMkUrWfDVEt+ACuQKFCCGhjv7jv8A9VodQr3gC76vNKeQ3i1nonhVoss3hgH2fvJIk7GqKaXwHAoEwi0Q/wHXWt4oJQIYQ75u5HG5sDFsibL8Noki5echnfR6IeeOr/40RZqpeuQS/J5AYFr1a4QnhMSQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/mentee_list_sort_descending.png
// module id = KqGR
// module chunks = 0